import { Separator } from "@/components/ui/separator";

const UserPreferences = () => {
    return (
        <div className="space-y-4">
            <div>
                <h3 className="text-lg font-medium">Preferencias</h3>
                <p className="text-sm text-muted-foreground">
                    Puedes modificar tus preferencias, alergias y otras cosas.
                </p>
            </div>
            <Separator />
            <p>Im the content</p>
        </div>
    );
};

export default UserPreferences;
